/******/ (() => { // webpackBootstrap
/* eslint-disable */
if (!customElements.get('quantity-input')) {
  customElements.define('quantity-input', class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.cacheDOMElements();
      this.bindEventHandlers();
    }

    cacheDOMElements() {
      /* ===== We need to cache the DOM elements in the constructor because the connectedCallback is called every time the element 
      is appended into the DOM ===== */
      this.input = this.querySelector('input');
      this.buttonMinus = this.querySelector("button[name='minus']");
      this.buttonPlus = this.querySelector("button[name='plus']");
      this.sectionId = this.getAttribute('data-section-id');
    }

    bindEventHandlers() {
      /* ===== Bind the event handlers in order to maintain the correct context of 'this' ===== */
      this.attachEventListeners = this.attachEventListeners.bind(this);
      this.detachEventListeners = this.detachEventListeners.bind(this);
      this.onButtonClick = this.onButtonClick.bind(this);
      this.onInput = this.debounce(this.onInput.bind(this), 500);
      this.onCartAdded = this.onCartAdded.bind(this);
    }

    connectedCallback() {
      this.attachEventListeners();
      this.setDisabled(this.hasAttribute('disabled'));
      this.commitValue(this.input?.value, false);
    }

    attachEventListeners() {
      /* ===== Attach the event listeners to the DOM elements ===== */
      this.buttonMinus?.addEventListener('click', this.onButtonClick);
      this.buttonPlus?.addEventListener('click', this.onButtonClick);
      this.input?.addEventListener('input', this.onInput);
      this.input?.addEventListener('change', this.onInput);
      eventBus.on('cart:added', this.onCartAdded);
    }

    debounce(func, wait, immediate) {
      /* ===== Debounce function to limit the rate at which a function is called ===== */
      let timeout;
      return function executedFunction() {
        const context = this;
        const args = arguments;
        
        const later = function() {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };

        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    }

    onButtonClick(event) {
      /* ===== Handle the button click event ===== */
      event.preventDefault();
      const previousValue = this.input.value;
      const step = this.getNumberAttribute('step', 1);
      const adjustment = event.currentTarget.name === 'plus' ? step : -step;

      // Adjust the quantity by the adjustment value
      this.adjustQuantity(adjustment);
      // Emit the qty:change event if the value has changed
      if (previousValue !== this.input.value) eventBus.emit('qty:change', { value: this.input.value, sectionId: this.sectionId });
    }

    onInput() {
      /* ===== Handle the input event ===== */
      this.commitValue(this.input?.value);
    }

    adjustQuantity(adjustment) {
      /* ===== Adjust the quantity by the adjustment value ===== */
      const currentValue = this.normaliseValue(this.input.value);
      this.commitValue(currentValue + adjustment, false);
    }

    getNumberAttribute(attribute, fallback = null) {
      const value = Number.parseInt(this.input?.getAttribute(attribute), 10);
      return Number.isFinite(value) ? value : fallback;
    }

    normaliseValue(value) {
      const minimum = this.getNumberAttribute('min', 1);
      const maximum = this.getNumberAttribute('max');
      const increment = Math.max(this.getNumberAttribute('step', 1), 1);
      let quantity = Number.parseInt(value, 10);

      if (!Number.isFinite(quantity)) quantity = minimum;
      quantity = Math.max(quantity, minimum);
      if (maximum !== null) quantity = Math.min(quantity, maximum);
      quantity = minimum + Math.round((quantity - minimum) / increment) * increment;
      if (maximum !== null) quantity = Math.min(quantity, maximum);
      return quantity;
    }

    commitValue(value, emitChange = true) {
      if (!this.input) return;
      this.input.value = String(this.normaliseValue(value));
      this.updateButtonStates();
      if (emitChange) eventBus.emit('qty:change', { value: this.input.value, sectionId: this.sectionId });
    }

    updateButtonStates() {
      if (!this.input) return;
      const value = this.normaliseValue(this.input.value);
      const minimum = this.getNumberAttribute('min', 1);
      const maximum = this.getNumberAttribute('max');
      const disabled = this.hasAttribute('disabled') || this.input.disabled;

      if (this.buttonMinus) this.buttonMinus.disabled = disabled || value <= minimum;
      if (this.buttonPlus) this.buttonPlus.disabled = disabled || (maximum !== null && value >= maximum);
    }

    setDisabled(disabled) {
      this.toggleAttribute('disabled', disabled);
      if (this.input) this.input.disabled = disabled;
      this.updateButtonStates();
    }

    onCartAdded(data) {
      /* ===== Handle the cart:added event and reset the input value to 1 ===== */
      if (data.sectionId && data.sectionId === this.sectionId) {
        this.commitValue(this.getNumberAttribute('min', 1), false);
      }
    }

    disconnectedCallback() {
      /* ===== Detach the event listeners when the element is removed from the DOM ===== */
      this.detachEventListeners();
    }

    detachEventListeners() {
      /* ===== Detach the event listeners from the DOM elements ===== */
      this.buttonMinus?.removeEventListener('click', this.onButtonClick);
      this.buttonPlus?.removeEventListener('click', this.onButtonClick);
      this.input?.removeEventListener('input', this.onInput);
      this.input?.removeEventListener('change', this.onInput);
      eventBus.off('cart:added', this.onCartAdded);
    }
  });
}
/******/ })()
;
